import React, { FC } from 'react'
import style from './ErrorMessageWiget.module.css'
import { Icon } from './components/Icon'

type ErrorMessageWigetProps = {
  header: string
  description: string
}

export const ErrorMessageWiget: FC<ErrorMessageWigetProps> = ({ header, description }) => (
  <div className={style.errorMessageWiget}>
    <Icon className={style.icon} />
    <div>
      <div className={style.header}>{header}</div>
      <div>{description}</div>
    </div>
  </div>
)
